import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class BulkUploadService extends RLBaseService {
    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    validateFileHeaders(request: Models.IBulkUploadValidateFileHeadersRequest) {
        return this.toRLService<{ [key: number]: Models.IBulkUploadValidationResult[] }>("/api/bulkupload/validatefileheaders").post(request).$promise;
    }

    ValidateFileData(request: Models.IBulkUploadValidateFileDataRequest) {
        return this.toRLService<Models.IJobResponse>("/api/bulkupload/validatefiledata").post(request).$promise;
    }

    saveStagingEntityCharData(token: string, stgEntityID: string, stgCharDatas: Models.ICharDatas, selectedDateFormat: string) {
        var data = {
            token: token,
            entityID: stgEntityID,
            charDatas: stgCharDatas,
            selectedDateFormat: selectedDateFormat
        };
        return this.toRLService<Models.IBulkUploadValidation>("/api/bulkupload/savestagingentitychardata").post(data).$promise;
    }

    saveStatgingEntitiesCharData(token: string, stgEntityIDs: number[], stgEntityID: string, stgCharDatas: Models.ICharDatas) {
        var data = {
            token: token,
            StagingIDs: stgEntityIDs,
            entityID: stgEntityID,
            charDatas: stgCharDatas
        };
        return this.toRLService<boolean>("/api/bulkupload/savestagingentitieschardata").post(data).$promise;
    }

    deleteStagingEntity(stgEntityID: string, token: string) {
        return this.toRLService<boolean>("/api/bulkupload/deleteentitystaging").delete({ stagingEntityID: stgEntityID, token: token }).$promise;
    }

    doBulkUpload(charTypeID: number, parentCharTypeID: number, parentRecordIDs: number[], token: string, assocCharTypeID: number, assocRel: number, fileName: string, mode: number, selectedDateFormat: string) {
        var data = {
            charTypeID: charTypeID,
            parentCharTypeID: parentCharTypeID,
            parentRecordIDs: parentRecordIDs,
            token: token,
            assocCharTypeID: assocCharTypeID,
            assocRel: assocRel,
            fileName: fileName,
            mode: mode,
            selectedDateFormat: selectedDateFormat
        };
        return this.toRLService<boolean>("/api/bulkupload/dobulkupload").post(data).$promise;
    }

    updateStagingEntitiesCharDataLov(token: string, charTypeID: number, recordIDs: number[], characteristicID: number, charValueSetID: string, jsonLov: string) {
        var data = {
            token: token,
            charTypeID: charTypeID,
            recordIDs: recordIDs,
            characteristicID: characteristicID,
            charValueSetID: charValueSetID,
            jsonLov: jsonLov
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/bulkupload/updateStagingEntitiesCharDataLov").post(data).$promise;
	}

    DoBulkImportV2(mode: number, charTypeID: number, templateIDs: number[], selectedParentCharTypeIDs: number[], fileName: string, selectedDateFormat: string, selectedAssocCharTypeHeaders: string[], selectedPartyNames: string[], mappedHeders: Models.IBulkUploadFileHeaderMapping[]) {
        var data = {
            mode: mode,
			charTypeID: charTypeID,
			templateIDs: templateIDs,
            parentCharTypeIDs: selectedParentCharTypeIDs,
			fileName: fileName,
			selectedDateFormat: selectedDateFormat,
			selectedAssocCharTypeHeaders: selectedAssocCharTypeHeaders,
            selectedPartyNames: selectedPartyNames,
            mappedHeaders: mappedHeders
		};
		return this.toRLService<Models.IJobResponse>("/api/bulkupload/dobulkimportv2").post(data).$promise;
	}

	DoBulkImportV3(charTypeID: number, fileName: string, selectedDateFormat: string) {
		var data = {
			charTypeID: charTypeID,			
			fileName: fileName,
			selectedDateFormat: selectedDateFormat
		};
		return this.toRLService<Models.IJobResponse>("/api/bulkupload/dobulkimportv3").post(data).$promise;
    }

    getFileHeaders(fileName: string) {
        var data = { fileName: fileName };
        return this.toRLService<Models.IDataResponse<{ [key: number]: Models.IBulkUploadFileHeaderMapping[] }>>("/api/bulkupload/GetFileHeader").post(data).$promise;
    }

    saveBulkUploadMapping(saveMapping: Models.ISavedBulkUploadV2HeaderMapping) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/bulkupload/saveBulkUploadMapping").post(saveMapping).$promise;
    }

    getSavedMappings(getMappings: Models.ISavedBulkUploadV2HeaderMapping) {
        return this.toRLService<Models.IDataResponse<Models.IBulkUploadSavedMapping[]>>("/api/bulkupload/getSavedMappings").post(getMappings).$promise;
    }

    getMappingDetails(getMapping: Models.ISavedBulkUploadV2HeaderMapping) {
        return this.toRLService<Models.IDataResponse<Models.IBulkUploadFileHeaderMapping[]>>("/api/bulkupload/getMappingDetails").post(getMapping).$promise;
    }

    deleteMapping(deleteMapping: Models.ISavedBulkUploadV2HeaderMapping) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/bulkupload/deleteMapping").post(deleteMapping).$promise;
    }
}
